// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from '../../types.tsx';
import { type SourceType, SHAREPOINT, GOOGLE_DRIVE } from '../../../../common/constants.tsx';

export const setAuthStatus =
	(provider: SourceType) =>
	async ({ getState, setState }: StoreActionApi<State>) => {
		const connectionStatus = getState().connectionStatus || {
			[SHAREPOINT]: null,
			[GOOGLE_DRIVE]: null,
		};

		setState({
			...getState(),
			connectionStatus: {
				...connectionStatus,
				[provider]: {
					...connectionStatus[provider],
					isUserOAuthed: true,
				},
			},
		});
	};
